import type { CurrentUser, RolePerms, Ticket, Topic, User } from './types';

export let tickets: Ticket[] = [];
export let selId: string | null = null;
export let filter = 'all';
export let priFilter = 'all';
export let notifyId: string | null = null;
export let apiUrl: string =
  sessionStorage.getItem('hr_api_url') ||
  localStorage.getItem('hr_api_url') ||
  'https://hr-ticket-bot.chanathip-tsw.workers.dev';
export let currentUser: CurrentUser | null = null;
export let topicsCache: Topic[] = [];
export let usersCache: User[] = [];
export let editingUserName: string | null = null;
export let adminEditingTopicIdx: number | null = null;
export let pollInterval: ReturnType<typeof setInterval> | null = null;
export let lastTicketIds: Set<string> = new Set();
export let sumDatePreset = 'all';
export let sumDateFrom: Date | null = null;
export let sumDateTo: Date | null = null;

const DEFAULT_ROLE_PERMS: Record<string, RolePerms> = {
  admin: { tickets: true, summary: true, topics: true, users: true, connection: true },
  hr:    { tickets: true, summary: true, topics: false, users: false, connection: false },
};
export let rolePerms: Record<string, RolePerms> =
  JSON.parse(localStorage.getItem('hr_role_perms') ?? 'null') ??
  JSON.parse(JSON.stringify(DEFAULT_ROLE_PERMS));

// Setters
export const set = {
  tickets: (v: Ticket[]) => { tickets = v; },
  selId: (v: string | null) => { selId = v; },
  filter: (v: string) => { filter = v; },
  priFilter: (v: string) => { priFilter = v; },
  notifyId: (v: string | null) => { notifyId = v; },
  apiUrl: (v: string) => { apiUrl = v; },
  currentUser: (v: CurrentUser | null) => { currentUser = v; },
  topicsCache: (v: Topic[]) => { topicsCache = v; },
  usersCache: (v: User[]) => { usersCache = v; },
  editingUserName: (v: string | null) => { editingUserName = v; },
  adminEditingTopicIdx: (v: number | null) => { adminEditingTopicIdx = v; },
  pollInterval: (v: ReturnType<typeof setInterval> | null) => { pollInterval = v; },
  lastTicketIds: (v: Set<string>) => { lastTicketIds = v; },
  sumDatePreset: (v: string) => { sumDatePreset = v; },
  sumDateFrom: (v: Date | null) => { sumDateFrom = v; },
  sumDateTo: (v: Date | null) => { sumDateTo = v; },
};
